import { useCompetitions as useCompetitionsQuery } from '../queries'

// Re-export with the same name for convenience; adds a helper for the active one.
export function useCompetitions() {
  const query = useCompetitionsQuery()
  const active = query.data?.find((c) => c.isActive) ?? null
  return { ...query, active }
}
